import { Box } from '@mui/material';
import { SyberryTodayPlanningStep } from 'domain/people/syberryToday/types';
import type { SyberryTodayPlanningFlowModel } from '../../types';
import SyberryTodayOrganizeBoard from '../SyberryTodayOrganizeBoard/SyberryTodayOrganizeBoard';
import SyberryTodaySelectBoard from '../SyberryTodaySelectBoard/SyberryTodaySelectBoard';
import SyberryTodaySelectPanel from '../SyberryTodaySelectPanel/SyberryTodaySelectPanel';
import SyberryTodaySkipCheckInModal from '../SyberryTodaySkipCheckInModal/SyberryTodaySkipCheckInModal';

type SyberryTodayPlanningFlowProps = {
  planningFlow: SyberryTodayPlanningFlowModel;
};

const PAGE_SX = {
  display: 'grid',
  flex: '1 1 auto',
  gridTemplateColumns: '320px minmax(0, 1fr)',
  width: '100%',
  minWidth: 0,
  minHeight: 'calc(100vh - 72px)',
  backgroundColor: 'background.default',
  color: 'text.primary',
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
  },
} as const;

const SyberryTodayPlanningFlow = ({ planningFlow }: SyberryTodayPlanningFlowProps) => {
  const { board, selectPanel, skipCheckIn } = planningFlow;

  return (
    <Box sx={PAGE_SX}>
      <SyberryTodaySelectPanel {...selectPanel} />
      {selectPanel.activeStep === SyberryTodayPlanningStep.SELECT_TASKS ? (
        <SyberryTodaySelectBoard
          activeGroup={board.activeGroup}
          activeProject={board.activeProject}
          allocationSummary={board.allocationSummary}
          isAllocationLoading={board.isAllocationLoading}
          isAllocationError={board.isAllocationError}
          streams={board.streams}
          tasks={board.tasks}
          expandedTaskId={board.expandedTaskId}
          onToggleSelection={board.onToggleSelection}
          onToggleExpansion={board.onToggleExpansion}
        />
      ) : (
        <SyberryTodayOrganizeBoard
          tasks={board.selectedTasks}
          focusTimeCurrentMinutes={board.focusTimeCurrentMinutes}
          focusTimeSlots={board.focusTimeSlots}
          expandedTaskId={board.expandedTaskId}
          onChangeFocusTimeSlots={board.onChangeFocusTimeSlots}
          onToggleExpansion={board.onToggleExpansion}
        />
      )}
      <SyberryTodaySkipCheckInModal {...skipCheckIn} />
    </Box>
  );
};

export default SyberryTodayPlanningFlow;
